module.exports = __webpack_public_path__ + "static/img/footer-hhb.f410334.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/global/footer-hhb.png
// module id = 923
// module chunks = 0